import React, { useState, useEffect, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from '@vkontakte/vkui';
import './index.css';
import './style/gmpui.css';
import axios from 'axios';
import App, { oneTapButton } from './App';
import MainScreen from './MainScreen';
import reportWebVitals from './reportWebVitals';
import MobileDetect from 'mobile-detect';

const root = ReactDOM.createRoot(document.getElementById('root'));
const tg = window.Telegram.WebApp;
const tg_id = tg.initDataUnsafe.user.id

axios.interceptors.request.use(config => {
    if (tg.initData) {
        config.headers['X-TG-INIT-DATA'] = tg.initData;
    }
    return config;
});

const originalFetch = window.fetch;
window.fetch = async (...args) => {
    let [resource, config] = args;
    const url = typeof resource === 'string' ? resource : (resource instanceof Request ? resource.url : resource);

    if (url && (typeof url === 'string') && url.includes('api.gmpapp.ru')) {
        config = config || {};
        let headers = config.headers || {};

        if (tg.initData) {
            if (headers instanceof Headers) {
                headers.set('X-TG-INIT-DATA', tg.initData);
            } else if (Array.isArray(headers)) {
                headers.push(['X-TG-INIT-DATA', tg.initData]);
            } else {
                headers['X-TG-INIT-DATA'] = tg.initData;
            }
        }
        config.headers = headers;
    }
    return originalFetch(resource, config);
};

function RootComponent() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [startTime, setStartTime] = useState(new Date()); // Изменили инициализацию на сразу установленное время
    // Определяем начальную тему и соответствующий цвет заголовка
    const initialTheme = window.Telegram.WebApp.colorScheme;
    const initialHeaderColor = initialTheme === "dark" ? "#0f0f0f" : "#fff";

    const [theme, setTheme] = useState(initialTheme); // Инициализируем состояние текущей темы
    const [headerColor, setHeaderColor] = useState(initialHeaderColor); // Инициализируем состояние цвета заголовка

    const [enableDarkMode, setEnableDarkMode] = useState(() => initialTheme === 'dark');

    useEffect(() => {
        const md = new MobileDetect(window.navigator.userAgent);

        // Проверяем, является ли устройство мобильным
        if (md.mobile()) {
            setIsMobile(false);
            // tg.requestFullscreen();
        } else {
            console.log('w/m/l');
        }
    }, []);

    useLayoutEffect(() => {
        document.documentElement.setAttribute(
            'data-prefers-color-scheme',
            enableDarkMode ? 'dark' : 'light'
        )
    }, [enableDarkMode])

    useEffect(() => {
        // Устанавливаем начальный цвет заголовка
        window.Telegram.WebApp.setHeaderColor(initialHeaderColor);
        window.Telegram.WebApp.setBottomBarColor(initialHeaderColor);
        window.Telegram.WebApp.setBackgroundColor(initialHeaderColor);

        // Функция для обработки события изменения темы
        const handleThemeChange = () => {
            const newTheme = window.Telegram.WebApp.colorScheme;
            setTheme(newTheme); // Обновляем тему в состоянии
            setEnableDarkMode(newTheme === 'dark');   // Обновляем enableDarkMode в зависимости от новой темы
            const newHeaderColor = newTheme === "dark" ? "#0f0f0f" : "#fff"; // Определяем цвет заголовка в зависимости от темы
            setHeaderColor(newHeaderColor); // Обновляем цвет заголовка в состоянии
            window.Telegram.WebApp.setHeaderColor(newHeaderColor); // Обновляем цвет заголовка в Telegram
            window.Telegram.WebApp.setBottomBarColor(newHeaderColor);
            window.Telegram.WebApp.setBackgroundColor(newHeaderColor);

        };

        // Подписываемся на событие изменения темы
        window.Telegram.WebApp.onEvent('themeChanged', handleThemeChange);

        // Отписываемся от события при размонтировании компонента
        return () => {
            window.Telegram.WebApp.offEvent('themeChanged', handleThemeChange);
        };
    }, []); // Пустой массив зависимостей, чтобы эффект выполнялся только при монтировании компонента

    useEffect(() => {
        const handleUnload = () => {
            const endTime = new Date(); // Получаем время при начале выгрузки страницы
            const duration = Math.floor((endTime - startTime) / 1000);

            // Создаём FormData
            const formData = new FormData();
            formData.append('tg_id', tg_id); // замените 'здесь-ваш-tg_id' на ваш фактический tg_id
            formData.append('visiting_time', duration.toString());

            navigator.sendBeacon('https://api.gmpapp.ru/visiting_time', formData);
        };

        // Подписываемся на событие перед выгрузкой страницы
        window.addEventListener('beforeunload', handleUnload);

        return () => {
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, [startTime]); // Используем startTime в массиве зависимостей

    const getOperatingSystem = () => {
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        let operatingSystem = '';

        if (/Win/i.test(platform)) {
            operatingSystem = 'Windows';
        } else if (/Mac/i.test(platform)) {
            operatingSystem = 'macOS';
        } else if (/Android/i.test(userAgent)) {
            operatingSystem = 'Android';
        } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
            operatingSystem = 'iOS';
        } else if (/Linux/i.test(platform)) {
            operatingSystem = 'Linux';
        } else {
            operatingSystem = 'Other';
        }

        return operatingSystem;
    };

    const operatingSystem = getOperatingSystem();

    const sendDataToAPI = (userId, operatingSystem) => {
        axios.post('https://api.gmpapp.ru/check_os', {
            tg_id: tg_id,
            os: operatingSystem
        })
            .then(response => {

            })
            .catch(error => {

            });
    };

    useEffect(() => {
        axios
            .post('https://api.gmpapp.ru/check-user', { tg_id: tg.initDataUnsafe.user.id })
            .then((response) => {
                const exists = response.data.exists;
                setIsLoggedIn(exists);
                sendDataToAPI(tg_id, operatingSystem);
            })
            .catch((error) => {
                console.error("Error checking user:", error);
            })
            .finally(() => {
                setIsDataLoaded(true);
            });
    }, []);

    useEffect(() => {
        if (isLoggedIn) {
            oneTapButton.destroy();
        }
    }, [isLoggedIn]);

    if (!isDataLoaded) {
        return null; // Отобразить загрузочный экран или спиннер, пока данные загружаются
    }

    const urlParams = new URLSearchParams(window.location.search);
    const payload = urlParams.get('payload');

    if (payload) {
        const decodedPayload = decodeURIComponent(payload);
        const event = JSON.parse(decodedPayload);

        const sendEventToFlask = (event) => {
            const payload = {
                ...event,
                tg_id: tg.initDataUnsafe.user.id
            };

            axios.post('https://api.gmpapp.ru/gmp_auth', payload)
                .then((response) => {
                    window.location.reload();
                })
                .catch((error) => {
                    console.error('Ошибка при отправке события в Flask:', error);
                });
        };

        sendEventToFlask(event);
    } else {

    }

    return (
        <>
            <ConfigProvider transitionMotionEnabled={true} platform="ios" hasCustomPanelHeaderAfter={false} appearance={theme}>
                {isLoggedIn ? <MainScreen isMobile={isMobile} /> : <App isMobile={isMobile} />}
            </ConfigProvider>
        </>
    );
}

root.render(<RootComponent />);
reportWebVitals();